import React, { Component } from 'react';
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';

import { AppAsideToggler, AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
//import logo from '../../assets/img/brand/logo.svg'
import logo from '../../assets/img/brand/logo.png';
import sygnet from '../../assets/img/brand/logo.png';

const propTypes = {
    children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {
    render() {
        // eslint-disable-next-line
        const { children, ...attributes } = this.props;
        const userEmail = JSON.parse(localStorage.getItem('user_email'));
        const userAvatar = JSON.parse(localStorage.getItem('user_avatar'));
        return (
            <React.Fragment>
                <AppSidebarToggler className="d-lg-none" display="md" mobile />
                    <AppNavbarBrand
                        full={{ src: logo, width: 140, height: 50, alt: 'CoreUI Logo' }}
                        minimized={{ src: sygnet, width: 30, height: 30, alt: 'CoreUI Logo' }}
                    />
                <AppSidebarToggler className="d-md-down-none" display="lg" />
                <Nav className="ml-auto" navbar>
                    <AppHeaderDropdown direction="down">
                        <DropdownToggle nav>
                            <img width={40} height={40} src={userAvatar ? userAvatar : '/assets/img/avatars/user.png'} className="img-avatar" alt={userEmail} />
                        </DropdownToggle>
                        <DropdownMenu right style={{ right: 'auto' }}>
                            <DropdownItem header tag="div" className="text-center"><strong>Configuración</strong></DropdownItem>
                            <DropdownItem onClick={this.props.onMyAccountClick}>
                                <i className="fa fa-user"></i> Mi cuenta
                            </DropdownItem>
                            <DropdownItem divider />
                            {/* <DropdownItem><i className="fa fa-shield"></i> Bloquear Pantalla</DropdownItem> */}
                            <DropdownItem onClick={this.props.logout}><i className="fa fa-lock"></i> Cerrar Sesión</DropdownItem>
                        </DropdownMenu>
                    </AppHeaderDropdown>
                </Nav>
                {/* <AppAsideToggler className="d-md-down-none" /> */}
                {/*<AppAsideToggler className="d-lg-none" mobile />*/}
        </React.Fragment>
        );
    }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;



// WEBPACK FOOTER //
// ./src/Containers/DefaultLayout/DefaultHeader.js